/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Kind_SeriesInputs */



/**
* | output |
* | --- |
* | "Open series" |
*
* @param {Tournament_Wiz_Kind_SeriesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_kind_series = /** @type {((inputs?: Tournament_Wiz_Kind_SeriesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Kind_SeriesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Série ouverte")
	if (locale === "es") return /** @type {LocalizedString} */ ("Serie abierta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Série aberta")
	if (locale === "it") return /** @type {LocalizedString} */ ("Serie aperta")
	return /** @type {LocalizedString} */ ("Open series")
});